import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../ThemeContext';

import { Wrapper, Box, Item } from './ApiDescriptionTabs.style';

const ApiDescriptionTabs = ({
  tabs = [],
  currentTab,
  handleChangeTab = () => {},
}) => {
  const theme = useTheme();

  return (
    <>
      {tabs && tabs.length > 0 ? (
        <Wrapper>
          <Box theme={theme.apiDescriptionTabs.box}>
            {tabs.map((tab, key) => (
              <Item
                theme={theme.apiDescriptionTabs.item}
                key={key}
                selected={tab.key === currentTab}
                onClick={() => {
                  handleChangeTab(tab.key);
                }}
              >
                {tab.name}
              </Item>
            ))}
          </Box>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
};

ApiDescriptionTabs.propTypes = {
  tabs: PropTypes.array,
  currentTab: PropTypes.number,
  handleChangeTab: PropTypes.func,
};

export default ApiDescriptionTabs;
